<ws-modal-wrapper headerLabel="Tax Authority"
                  [loading]="!taxAuthority"
                  [hideSave]="true"
                  [excludeModalStyling]="true"
                  cancelLabel="Close"
                  (cancel)="closeModal()">
    @if (taxAuthority) {
        <div class="d-flex flex-column ws-stretch">
            <div class="ws-section">
                <div class="ws-section__header">
                    <div class="ws-section__header__actions__right">
                        @if (canEdit) {
                            <div class="ws-section__header__actions__item">
                                @if (!editMode) {
                                    <button
                                        type="button"
                                        class="ace-btn btn-sm btn-primary has-icon"
                                        (click)="goToEditMode()"
                                        title="Edit">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                }
                                @if (!editMode) {
                                    <button
                                        type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                        (click)="delete()"
                                        title="Delete">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                }
                                @if (editMode) {
                                    <button
                                        type="button"
                                        class="ace-btn btn-sm btn-primary has-icon"
                                        (click)="save()"
                                        title="Save"
                                        [disabled]="saving || !taxAuthority.name">
                                        <i class="fa fa-save"></i>
                                    </button>
                                }
                                @if (editMode && taxAuthority.taxAuthorityId) {
                                    <button
                                        type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                        (click)="cancel()"
                                        title="Cancel"
                                        [disabled]="saving">
                                        <i class="fa fa-close"></i>
                                    </button>
                                }
                            </div>
                        }
                        <div class="ws-section__header__actions__item">
                            <entity-attachments buttonClass="ace-btn btn-sm btn-primary"
                                                [isNestedModal]="true"
                                                [(hasAttachments)]="taxAuthority.hasAttachments"
                                                [modalData]="attachmentsModel">
                            </entity-attachments>
                            <entity-comments buttonClass="ace-btn btn-sm btn-primary"
                                             [(hasComments)]="taxAuthority.hasComments"
                                             [isNestedModal]="true"
                                             [modalData]="commentsModel">
                            </entity-comments>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <div class="d-flex flex-column flex-grow-1 me-3" style="height: initial;">
                    <div class="card panel-flat-color primary-panel m-0 pb-0 h-100">
                        <div class="panel-flat-header">
                            <h3>Info</h3>
                        </div>
                        <div class="panel-flat-body">
                            <table class="tax-authority-info">
                                <tr>
                                    <td>Name:</td>
                                    <td>
                                        @if (!editMode) {
                                            <span>{{ taxAuthority.name }}</span>
                                        }
                                        @if (editMode) {
                                            <input class="form-control"
                                                   type="text"
                                                   [(ngModel)]="taxAuthority.name"
                                                   maxlength="100">
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Code:</td>
                                    <td>
                                        @if (!editMode) {
                                            <span>{{ taxAuthority.code }}</span>
                                        }
                                        @if (editMode) {
                                            <input class="form-control"
                                                   type="text"
                                                   [(ngModel)]="taxAuthority.code"
                                                   maxlength="50">
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>PTX ID:</td>
                                    <td>
                                        @if (!editMode) {
                                            <span>{{ taxAuthority.ptxId }}</span>
                                        }
                                        @if (editMode) {
                                            <input class="form-control"
                                                   type="text"
                                                   [(ngModel)]="taxAuthority.ptxId"
                                                   maxlength="50">
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td style="vertical-align: top; padding-top: 7px;">Address:</td>
                                    <td>
                                        <address-view-edit [address]="taxAuthority.address"
                                                           [isSmall]="true"
                                                           [isEditMode]="editMode"
                                                           [readOnlyState]="true">
                                        </address-view-edit>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Category:</td>
                                    <td>
                                        @if (!editMode) {
                                            <span>{{ getCategory(taxAuthority.taxAuthorityCategoryId) }}</span>
                                        }
                                        @if (editMode) {
                                            <select
                                                class="form-select form-select-sm"
                                                style="width: auto;"
                                                [(ngModel)]="taxAuthority.taxAuthorityCategoryId">
                                                @for (category of categories; track category) {
                                                    <option [ngValue]="category.id">{{ category.label }}</option>
                                                }
                                            </select>
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Taxable Assessment:</td>
                                    <td>
                                        @if (!editMode) {
                                            <span>{{ getTaxableAssessmentLabel(taxAuthority.taxableAssessmentTypeId) }}</span>
                                        }
                                        @if (editMode) {
                                            <select
                                                class="form-select form-select-sm"
                                                style="width: auto;"
                                                [(ngModel)]="taxAuthority.taxableAssessmentTypeId">
                                                @for (option of taxableAssessments; track option) {
                                                    <option [ngValue]="option.id">{{ option.label }}</option>
                                                }
                                            </select>
                                        }
                                    </td>
                                </tr>
                                @if (editMode || taxAuthority.taxAuthorityExemptionTypeId === exemptions.allExemptions) {
                                    <tr>
                                        <td>Exemptions Honored:</td>
                                        <td>
                                            @if (!editMode) {
                                                <span>All</span>
                                            }
                                            @if (editMode) {
                                                <div class="radio my-0">
                                                    <label>
                                                        <input type="radio"
                                                               name="taxAuthorityExemptionType"
                                                               [value]="exemptions.allExemptions"
                                                               [(ngModel)]="taxAuthority.taxAuthorityExemptionTypeId"
                                                               [disabled]="!editMode">
                                                        All
                                                    </label>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                }
                                @if (editMode || taxAuthority.taxAuthorityExemptionTypeId === exemptions.noExemptions) {
                                    <tr>
                                        @if (editMode) {
                                            <td>&nbsp;</td>
                                        }
                                        @if (!editMode && taxAuthority.taxAuthorityExemptionTypeId === exemptions.noExemptions) {
                                            <td>Exemptions Honored:</td>
                                        }
                                        <td>
                                            @if (!editMode) {
                                                <span>None</span>
                                            }
                                            @if (editMode) {
                                                <div class="radio my-0">
                                                    <label>
                                                        <input type="radio" name="taxAuthorityExemptionType"
                                                               [value]="exemptions.noExemptions"
                                                               [(ngModel)]="taxAuthority.taxAuthorityExemptionTypeId">
                                                        None
                                                    </label>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                }
                                @if (editMode || taxAuthority.taxAuthorityExemptionTypeId === exemptions.certainExemptions) {
                                    <tr>
                                        @if (editMode) {
                                            <td>&nbsp;</td>
                                        }
                                        @if (!editMode && taxAuthority.taxAuthorityExemptionTypeId === exemptions.certainExemptions) {
                                            <td>Exemptions Honored:</td>
                                        }
                                        <td>
                                            @if (!editMode) {
                                                <span>Certain Exemptions:</span>
                                            }
                                            @if (editMode) {
                                                <div class="radio my-0">
                                                    <label>
                                                        <input type="radio"
                                                               name="taxAuthorityExemptionType"
                                                               [value]="exemptions.certainExemptions"
                                                               [(ngModel)]="taxAuthority.taxAuthorityExemptionTypeId">
                                                        Certain Exemptions
                                                    </label>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                }
                                @if (editMode || taxAuthority.taxAuthorityExemptionTypeId === exemptions.certainExemptions) {
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>
                                            @if (allowedExemptions && allowedExemptions.length > 0) {
                                                <div class="ps-2">
                                                    <checkbox-list [(ngModel)]="allowedExemptions"
                                                                   [disabled]="!editMode || taxAuthority.taxAuthorityExemptionTypeId !== exemptions.certainExemptions"
                                                                   [helpDisabled]="!editMode || taxAuthority.taxAuthorityExemptionTypeId === exemptions.certainExemptions"
                                                                   [helpContentId]="'tax-authority.certain-exemptions-disabled'"
                                                                   [viewOnly]="!editMode">
                                                    </checkbox-list>
                                                </div>
                                            }
                                            @if (allowedExemptions && allowedExemptions.length === 0) {
                                                <div class="checkbox ms-0 my-0">
                                                    <label>(No exemptions defined for this Tax Authority)</label>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                }
                                @if (((!editMode &&
                                        taxAuthority.allowExemptionsOnAlternateAV &&
                                        taxAuthority.taxableAssessmentTypeId === taxableAssessmentTypes.lowerOfTotalAvAndAlternateAv)
                                    ||
                                    (editMode &&
                                        taxAuthority.taxableAssessmentTypeId === taxableAssessmentTypes.lowerOfTotalAvAndAlternateAv))) {
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>
                                            <div class="checkbox my-0"
                                                 helpTooltip
                                                 helpContentId="tax-authority.honor-exemptions-on-alternate-av-disabled"
                                                 [helpDisabled]="!editMode || taxAuthority.taxableAssessmentTypeId === taxableAssessmentTypes.lowerOfTotalAvAndAlternateAv">
                                                @if (editMode) {
                                                    <label
                                                        [class.disabled]="taxAuthority.taxableAssessmentTypeId !== taxableAssessmentTypes.lowerOfTotalAvAndAlternateAv">
                                                        <input type="checkbox"
                                                               [(ngModel)]="taxAuthority.allowExemptionsOnAlternateAV"
                                                               [disabled]="taxAuthority.taxableAssessmentTypeId !== taxableAssessmentTypes.lowerOfTotalAvAndAlternateAv">
                                                        Also honor exemptions on Alternate AV
                                                    </label>
                                                }
                                                @if (!editMode && taxAuthority.allowExemptionsOnAlternateAV) {
                                                    <span>
                                                        <i class="fa fa-check me-1"></i>
                                                        Also honor exemptions on Alternate AV
                                                    </span>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                                @if (taxAuthority) {
                                    <tr>
                                        <td>Typical Certification Date:</td>
                                        <td>
                                            @if (!editMode && taxAuthority.certificationMonth && taxAuthority.certificationDay) {
                                                <span>{{ taxAuthority.certificationMonth }}
                                                    /{{ taxAuthority.certificationDay }}  {{ getCertificationType() }}</span>
                                            }
                                            @if (editMode) {
                                                <div>
                                                    <select class="form-select form-select-sm"
                                                            style="width: auto; display: inline-block;"
                                                            [(ngModel)]="taxAuthority.certificationMonth">
                                                        <option [ngValue]="null"></option>
                                                        @for (option of certificationMonths; track option) {
                                                            <option [ngValue]="option">{{ option }}</option>
                                                        }
                                                    </select>
                                                    <span>/</span>
                                                    <select class="form-select form-select-sm"
                                                            style="width: auto; display: inline-block;"
                                                            [(ngModel)]="taxAuthority.certificationDay">
                                                        <option [ngValue]="null"></option>
                                                        @for (option of certificationDays; track option) {
                                                            <option [ngValue]="option">{{ option }}</option>
                                                        }
                                                    </select>
                                                    <select class="form-select form-select-sm"
                                                            style="width: auto; display: inline-block;"
                                                            [(ngModel)]="taxAuthority.certificationType">
                                                        <option [ngValue]="null"></option>
                                                        @for (option of certificationTypes; track option) {
                                                            <option [ngValue]="option.id">{{ option.label }}</option>
                                                        }
                                                    </select>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                }
                            </table>
                            <div class="checkbox">
                                @if (editMode) {
                                    <label>
                                        <input type="checkbox"
                                               [(ngModel)]="taxAuthority.obtainInAdvance">
                                        Obtain in advance of first encounter
                                    </label>
                                }
                                @if (!editMode && taxAuthority.obtainInAdvance) {
                                    <span>
                                        <i class="fa fa-check me-1"></i>
                                        Obtain in advance of first encounter
                                    </span>
                                }
                            </div>
                            <div style="margin-top: 20px;">
                                @if (taxAuthority.disabled) {
                                    <div class="checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="taxAuthority.disabled"
                                                [disabled]="!editMode">
                                            Disabled
                                        </label>
                                    </div>
                                }
                                @if (editMode && !taxAuthority.disabled) {
                                    <button
                                        class="ace-btn btn-primary btn-danger btn-sm"
                                        (click)="disableTaxAuthority()"
                                        style="margin: 0;">
                                        Disable
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column w-min-0">
                    <div class="card panel-flat-color secondary-panel flex-panel mb-3"
                         style="padding-bottom: 0; width: initial;">
                        <div class="panel-flat-header" style="margin-bottom: 0;">
                            <h3>Rates</h3>
                        </div>
                        <div class="panel-flat-body d-flex flex-column" style="justify-content: space-between; ">
                            <div>
                                <div class="d-flex ws-flex-align-items-center tax-rates-form-items">
                                    <label style="margin-bottom: 0;">Display as:</label>
                                    <div class="radio">
                                        <label>
                                            <input type="radio"
                                                   name="displayAsPctOrMillsRadioButton"
                                                   value="rate"
                                                   [(ngModel)]="displayAs">
                                            Rate
                                        </label>
                                    </div>
                                    <div class="radio" style="margin-top: 10px;">
                                        <label>
                                            <input type="radio"
                                                   name="displayAsPctOrMillsRadioButton"
                                                   value="mills"
                                                   [(ngModel)]="displayAs">
                                            Mills
                                        </label>
                                    </div>
                                </div>
                                <div class="d-flex ws-flex-align-items-center tax-rates-form-items">
                                    <label>Default Annual Rate Increase (%):</label>
                                    @if (!editMode) {
                                        <span>{{ taxAuthority.defaultAnnualRateIncreaseAsPct }}</span>
                                    }
                                    @if (editMode) {
                                        <input type="number"
                                               style="width: 100px; text-align: right;"
                                               class="form-control"
                                               [(ngModel)]="taxAuthority.defaultAnnualRateIncreaseAsPct"
                                               (ngModelChange)="syncDefaultAnnualRateIncrease()"
                                               (blur)="defaultAnnualRateIncreaseAsPctBlur()">
                                    }
                                </div>
                            </div>
                            <div style="height: 158px; overflow: auto; margin: 20px 0;">
                                <table class="table table-condensed tax-authority-details">
                                    <thead>
                                        <tr>
                                            <th>Tax Year *</th>
                                            @if (displayAs === 'rate') {
                                                <th style="text-align: right;">Rate</th>
                                            }
                                            @if (displayAs === 'mills') {
                                                <th style="text-align: right;">Mills</th>
                                            }
                                            <th style="text-align: right;">YoY % Change</th>
                                            <th>Status</th>
                                            <th style="text-align: right;">Bills Utilizing</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (yearDetail of taxAuthority.details; track yearDetail; let i = $index) {
                                            @if (yearDetail.efAction !== 'delete') {
                                                <tr>
                                                    <td>{{ yearDetail.taxYear }}</td>
                                                    <td [ngClass]="getShadingFromStatus(yearDetail)"
                                                        style="text-align: right;"
                                                        [tooltip]="getQcInfo(yearDetail)"
                                                        container="body">
                                                        @if (!editMode) {
                                                            <div>
                                                                @if (displayAs === 'rate') {
                                                                    <span>{{ yearDetail.rateAsPct }}</span>
                                                                }
                                                                @if (displayAs === 'mills') {
                                                                    <span>{{ yearDetail.rateAsMills }}</span>
                                                                }
                                                            </div>
                                                        }
                                                        @if (editMode && displayAs === 'mills') {
                                                            <input type="text"
                                                                   [ngClass]="'form-control mills' + i"
                                                                   style="text-align: right;"
                                                                   [(ngModel)]="yearDetail.rateAsMills"
                                                                   (ngModelChange)="syncRateFromMillsToPct(yearDetail)"
                                                                   (focus)="captureVal(yearDetail, 'rateAsMills')"
                                                                   (blur)="rateAsMillsBlur(yearDetail)">
                                                        }
                                                        @if (editMode && displayAs === 'rate') {
                                                            <input type="text"
                                                                   [ngClass]="'form-control rate' + i"
                                                                   style="text-align: right;"
                                                                   [(ngModel)]="yearDetail.rateAsPct"
                                                                   (ngModelChange)="syncRateFromPctToMills(yearDetail)"
                                                                   (focus)="captureVal(yearDetail, 'rateAsPct')"
                                                                   (blur)="rateAsPctBlur(yearDetail)">
                                                        }
                                                    </td>
                                                    <td [ngClass]="getShadingFromStatus(yearDetail)"
                                                        style="text-align: right;">
                                                        @if (!editMode) {
                                                            <div>
                                                                @if (yearDetail.rateChangeAsPercent !== null && yearDetail.rateChangeAsPercent !== undefined) {
                                                                    <span>{{ yearDetail.rateChangeAsPercent }}</span>
                                                                }
                                                                @if (yearDetail.rateChangeAsPercent === null || yearDetail.rateChangeAsPercent === undefined) {
                                                                    <span>N/A</span>
                                                                }
                                                            </div>
                                                        }
                                                        @if (editMode && taxAuthority.details[i + 1]) {
                                                            <input type="text"
                                                                   class="form-control"
                                                                   style="text-align: right;"
                                                                   [(ngModel)]="yearDetail.rateChangeAsPercent"
                                                                   (ngModelChange)="syncRateChange(yearDetail)"
                                                                   (focus)="captureVal(yearDetail, 'rateChangeAsPercent')"
                                                                   (blur)="rateChangeAsPercentBlur(yearDetail)">
                                                        }
                                                    </td>
                                                    <td>
                                                        @if (!editMode) {
                                                            <span>{{ getStatus(yearDetail.taxAuthorityStatusId) }}</span>
                                                        }
                                                        @if (editMode) {
                                                            <select
                                                                class="form-select form-select-sm d-inline-block"
                                                                [(ngModel)]="yearDetail.taxAuthorityStatusId">
                                                                @for (option of statuses; track option) {
                                                                    <option [ngValue]="option.id">{{ option.label }}</option>
                                                                }
                                                            </select>
                                                        }
                                                    </td>
                                                    <td style="text-align: right;">{{ yearDetail.billsUtilizing }}</td>
                                                    <td>
                                                        <button [class.invisible]="!editMode"
                                                                class="ace-btn has-icon btn-primary btn-danger btn-sm m-0"
                                                                (click)="removeYearDetail(yearDetail)">
                                                            <i class="fa fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    </tbody>
                                </table>
                            </div>
                            @if (editMode) {
                                <div>
                                    <button type="button"
                                            class="ace-btn btn-primary btn-sm"
                                            (click)="launchAddTaxYearModal()">
                                        Add Tax Year
                                    </button>
                                </div>
                            }
                            <p style="margin: 0;">* When calculating bill tax amounts, taxes for years not listed with
                                project using the default annual rate increase.</p>
                        </div>
                    </div>
                    <div class="card panel-flat-color secondary-panel flex-panel" style="width: initial;">
                        <div class="panel-flat-header">
                            <h3>Tax Rate Area Inclusion</h3>
                        </div>
                        <div class="panel-flat-body d-flex flex-column"
                             style="height: 172px; overflow: auto; margin: 20px 0;">
                            <table class="table table-condensed">
                                <thead>
                                    <tr>
                                        <th>Tax Rate Area</th>
                                        @for (yearDetail of taxAuthority.details; track yearDetail) {
                                            <th style="text-align: center;">{{ yearDetail.taxYear }}</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (traInclusion of taxRateAreaInclusions; track traInclusion) {
                                        <tr>
                                            <td>{{ traInclusion.taxRateAreaName }}</td>
                                            @for (yearIncluded of traInclusion.yearsIncluded; track $index) {
                                                <td style="text-align: center;">
                                                    @if (yearIncluded) {
                                                        <i class="fa fa-check"></i>
                                                    }
                                                </td>
                                            }
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</ws-modal-wrapper>
